import { observer } from 'mobx-react-lite'
import { useLoaderData } from 'react-router'
import { useFeatures } from '@/contexts/root-store-context'
import type { JobDetailsViewLoaderData } from '@/features/jobs/job-route-loaders'
import { JobRootViewContainer } from './JobRootViewContainer'

export default observer(function JobRootContainer() {
  const data = useLoaderData<JobDetailsViewLoaderData>()
  const { internal } = useFeatures(({ jobs }) => ({
    internal: jobs.internal(),
  }))

  return <JobRootViewContainer rootVm={internal.jobRootViewModel} data={data} />
})
